module.exports = __webpack_public_path__ + "img/promo_detailed_bg.62210791.jpg";